var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-left"},[(_vm.cartOrder.payment.deduction.total > 0)?_c('div',{staticClass:"saved-text"},[_vm._v("Saved: -"+_vm._s(_vm._f("currency")(_vm.cartOrder.payment.deduction.total)))]):_vm._e(),_c('div',[_vm._v("Total: "+_vm._s(_vm._f("currency")(_vm.cartOrder.payment.total)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }